import {
  Component,
  Input,
  Output,
  EventEmitter,
  Inject,
  Optional
} from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "beneficiary-add-modal",
    templateUrl: "./beneficiary-add-modal.component.html",
    styleUrls: ["./beneficiary-add-modal.component.scss"],
    standalone: true,
    imports: [ReactiveFormsModule]
})
export class BeneficiaryAddModalComponent {
  form: UntypedFormGroup;
  attemptedSubmit = false;
  @Output() close = new EventEmitter();
  @Output() submit = new EventEmitter<{ password: string; id: string }>();

  constructor(
    private builder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<BeneficiaryAddModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.builder.group({
      title: [null, [Validators.required]]
    });
  }

  closeModal() {
    this.resetModal();
    this.close.emit();
    this.dialogRef.close(null);
  }

  resetModal() {
    this.form.reset();
    this.attemptedSubmit = false;
  }

  submitForm() {
    console.log("Am submitting");
    this.attemptedSubmit = true;
    if (this.form.valid) {
      this.submit.emit(this.form.value);
      this.dialogRef.close(this.form.value);
      this.resetModal();
    }
  }
}
